import { useState, useEffect } from 'react';
import MainHeader from '../home/MainHeader';
import Footer from '../Footer';
import BillboardImage from '../home/components/BillboardImage';
import { CookiesMessage } from '../footer/CookiesMessage';
import { FloatingButtonGroup } from '../ui';

const UnifiedLayout = ({ children, showSearchBar = false, showBillboard = true, hideFAB = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className='relative min-h-screen'>
        <div
          className={`fixed top-0 left-0 right-0 z-20 transition-all duration-300 ${
            isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
          }`}
        >
          <MainHeader isScrolled={isScrolled} />
        </div>
        {showBillboard && (
          <div className='relative w-full'>
            <BillboardImage />
          </div>
        )}
        <div className={`relative z-10 ${!showSearchBar ? 'packages-container' : ''}`}>
          {children}
        </div>
      </div>
      <Footer />
      <CookiesMessage />
      {!hideFAB && (
        <FloatingButtonGroup />
      )}
    </>
  );
};

export default UnifiedLayout;
